var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fish",style:(`
    background-color:${_vm.chip.color.secondary}; 
    border-color:${_vm.chip.color.primary};
    color:${_vm.chip.color.primary};
    box-shadow: ${_vm.chip.color.secondary} 0px 0px 0px 1.5px inset, ${_vm.chip.color.primary} 0px 0px 0px 3.5px inset, ${_vm.chip.color.secondary} 0px 0px 4px 2px inset, rgba(0, 0, 0, 0.34) -1px -20px 20px 0px inset, rgba(113, 113, 113, 0.36) 0px 0px 5px 3px;
    `),on:{"click":function($event){return _vm.$emit('clicked', _vm.chip)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.nFormatter(_vm.chip.number, 0))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }